import _map from 'lodash/map';
import APPCONFIG from '../../constants/Config';
import { WS_TOPIC_SCENARIOS } from '../../constants/App';
import * as wsEvents from '../../constants/WsEvents';
import {
  REINIT_STATE,
  WS_RECEIVED_OPERATION,
  GET_INSTALLATION_SCENARIOS,
  GET_INSTALLATION_SCENARIOS_SUCCESS,
  GET_INSTALLATION_SCENARIOS_ERROR,
  ADD_INSTALLATION_SCENARIO,
  ADD_INSTALLATION_SCENARIO_SUCCESS,
  ADD_INSTALLATION_SCENARIO_ERROR,
  DELETE_INSTALLATION_SCENARIO,
  DELETE_INSTALLATION_SCENARIO_SUCCESS,
  DELETE_INSTALLATION_SCENARIO_ERROR,
  GET_INSTALLATION_SCENARIO,
  GET_INSTALLATION_SCENARIO_SUCCESS,
  GET_INSTALLATION_SCENARIO_ERROR,
  UPDATE_INSTALLATION_SCENARIO,
  UPDATE_INSTALLATION_SCENARIO_SUCCESS,
  UPDATE_INSTALLATION_SCENARIO_ERROR,
  DUPLICATE_SCENARIO,
  TRIGGER_INSTALLATION_SCENARIO,
  TRIGGER_INSTALLATION_SCENARIO_SUCCESS,
  TRIGGER_INSTALLATION_SCENARIO_ERROR,
} from '../../constants/ActionTypes';
// Models
/* eslint-disable import/named */
import { deserialize } from '../../models/scenario';
/* eslint-enable import/named */

const initialSettings = APPCONFIG.installationScenario;
const installationScenario = (state = initialSettings, action) => {
  let key;
  let wsPayload;
  switch (action.type) {
    // REINIT STATE
    case REINIT_STATE:
      key = null;
      if (action.target === 'fullInstallation' || action.target === 'currentInstallation') {
        return {
          ...state,
          list: { ...initialSettings.list },
          current: { ...initialSettings.current },
          add: { ...initialSettings.add },
          update: { ...initialSettings.update },
          delete: { ...initialSettings.delete },
          trigger: { ...initialSettings.trigger },
        };
      }
      switch (action.target) {
        case 'addInstallationScenario':
          key = 'add';
          break;
        case 'updateInstallationScenario':
          key = 'update';
          break;
        case 'duplicateInstallationScenario':
          key = 'duplicate';
          break;
        default:
          break;
      }
      if (key) {
        return {
          ...state,
          [key]: {
            ...initialSettings[key],
          },
        };
      }
      return state;
    // WEB SOCKET
    case WS_RECEIVED_OPERATION:
      if (action.topic && action.topic === WS_TOPIC_SCENARIOS) {
        switch (action.operation) {
          case wsEvents.EVENT_CREATE:
          case wsEvents.EVENT_UPDATE:
          case wsEvents.EVENT_DELETE:
            return {
              ...state,
              list: {
                ...state.list,
                desynchronized: true,
              },
            };
          case wsEvents.EVENT_HEAD:
            wsPayload = action.payload;
            if (wsPayload) {
              // Update the list of scenarios by updating sync status of the concerned scenario
              return {
                ...state,
                list: {
                  ...state.list,
                  elements: _map(state.list.elements, (scenario) => (scenario.id === wsPayload.id
                    ? {
                      ...scenario,
                      sync_status: wsPayload.sync_status,
                    } : scenario
                  )),
                },
              };
            }
            return state;
          default:
            return state;
        }
      }
      return state;
    // LIST SCENARIOS
    case GET_INSTALLATION_SCENARIOS:
      return {
        ...state,
        list: {
          ...state.list,
          elements: null,
          error: null,
          loading: true,
          desynchronized: false,
        },
      };
    case GET_INSTALLATION_SCENARIOS_ERROR:
      return {
        ...state,
        list: {
          ...state.list,
          error: action.error,
          loading: false,
          desynchronized: false,
        },
      };
    case GET_INSTALLATION_SCENARIOS_SUCCESS:
      return {
        ...state,
        list: {
          ...state.list,
          elements: deserialize(action.data.data),
          loading: false,
          desynchronized: false,
        },
      };
    // ADD SCENARIO
    case ADD_INSTALLATION_SCENARIO:
      return {
        ...state,
        add: {
          ...state.add,
          added: false,
          error: null,
        },
      };
    case ADD_INSTALLATION_SCENARIO_ERROR:
      return {
        ...state,
        add: {
          ...state.add,
          error: action.error,
        },
      };
    case ADD_INSTALLATION_SCENARIO_SUCCESS:
      return {
        ...state,
        add: {
          ...state.add,
          added: true,
          asyncOperation: action.data.data,
        },
      };
    // DELETE SCENARIO
    case DELETE_INSTALLATION_SCENARIO:
      return {
        ...state,
        delete: {
          ...state.delete,
          deleted: false,
          error: null,
          idScenario: action.idScenario,
        },
      };
    case DELETE_INSTALLATION_SCENARIO_ERROR:
      return {
        ...state,
        delete: {
          ...state.delete,
          error: action.error,
        },
      };
    case DELETE_INSTALLATION_SCENARIO_SUCCESS:
      return {
        ...state,
        delete: {
          ...state.delete,
          deleted: true,
        },
      };
    // GET
    case GET_INSTALLATION_SCENARIO:
      return {
        ...state,
        current: {
          ...state.current,
          loading: true,
          data: null,
          error: null,
        },
      };
    case GET_INSTALLATION_SCENARIO_ERROR:
      return {
        ...state,
        current: {
          ...state.current,
          loading: false,
          error: action.error,
        },
      };
    case GET_INSTALLATION_SCENARIO_SUCCESS:
      return {
        ...state,
        current: {
          ...state.current,
          loading: false,
          data: deserialize(action.data.data),
        },
      };
    // UPDATE
    case UPDATE_INSTALLATION_SCENARIO:
      return {
        ...state,
        update: {
          ...state.update,
          error: null,
          updated: false,
          idScenario: action.idScenario,
        },
      };
    case UPDATE_INSTALLATION_SCENARIO_ERROR:
      return {
        ...state,
        update: {
          ...state.update,
          error: action.error,
        },
      };
    case UPDATE_INSTALLATION_SCENARIO_SUCCESS:
      return {
        ...state,
        update: {
          ...state.update,
          updated: true,
          asyncOperation: action.data.data,
        },
      };
    // DUPLICATE
    case DUPLICATE_SCENARIO:
      return {
        ...state,
        duplicate: {
          ...state.duplicate,
          data: action.data,
        },
      };
    // TRIGGER
    case TRIGGER_INSTALLATION_SCENARIO:
      return {
        ...state,
        trigger: {
          ...state.trigger,
          error: null,
          done: false,
          idScenario: action.idScenario,
        },
      };
    case TRIGGER_INSTALLATION_SCENARIO_ERROR:
      return {
        ...state,
        trigger: {
          ...state.trigger,
          error: action.error,
        },
      };
    case TRIGGER_INSTALLATION_SCENARIO_SUCCESS:
      return {
        ...state,
        trigger: {
          ...state.trigger,
          done: true,
          asyncOperation: action.data.data,
        },
      };
    default:
      return state;
  }
};

export default installationScenario;



// WEBPACK FOOTER //
// ./reducers/installation/installationScenario.js